<div #headerRow class="page-header" [class.is-searching]="searchFocused">
  <div class="page-header-title" [class.xlarge-title]="titleSize === 'xlarge'">
    <ui-button
      *ngIf="showBackButton"
      type="secondary"
      icon="arrow-left"
      (click)="onBackButtonClick()"
    >
    </ui-button>
    <ui-icon
      *ngIf="lucideIcon; else legacyIcon"
      [name]="lucideIcon"
      size="xlarge"
      class="page-header-title-icon">
    </ui-icon>
    <ng-template #legacyIcon>
      <ui-svg-icon *ngIf="icon" [svgIcon]="icon" [size]="titleSize" class="page-header-title-icon"></ui-svg-icon>
    </ng-template>
    <nav class="breadcrumbs" *ngIf="breadcrumbs.length > 0">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
        <ng-container *ngIf="crumb.link">
          <a [routerLink]="crumb.link">{{ crumb.label }}</a>
        </ng-container>
        <ng-container *ngIf="!crumb.link">
          <span class="current">{{ crumb.label }}</span>
        </ng-container>
        <div class="divider">
          <ui-svg-icon svgIcon="chevron_right" size="large"></ui-svg-icon>
        </div>
      </ng-container>
    </nav>
    <h1 class="header-title" [class.header-title--current]="breadcrumbs.length > 0">{{ title }}</h1>
    <span *ngIf="titleTag" class="{{ titleTagType }}--tag">{{ titleTag }}</span>
  </div>
  <div class="actions">
    <div
      class="page-header-search"
      *ngIf="searchable"
      [style.transform]="searchFocused ? 'translateX(' + searchShift + 'px)' : null"
    >
      <ui-icon name="Search" size="medium" class="page-header-search-icon"></ui-icon>
      <input
        #searchField
        type="text"
        [formControl]="searchControl"
        [placeholder]="searchPlaceholder"
        [attr.data-testid]="searchTestId || null"
        (input)="searchInput.emit($event)"
        (focus)="onSearchFocus()"
        (blur)="searchFocused = false"
        (keydown.escape)="searchField.blur()"
      />
      <span class="page-header-search-hint" *ngIf="searchFocused">ESC</span>
    </div>
    <!-- Projected actions are wrapped so they can step aside as one block while
         the search field is expanded. -->
    <div class="actions-items">
      <ng-content></ng-content>
    </div>
  </div>
</div>
